import React, { useEffect } from "react";
import { isIOSDevice, isAndroidDevice } from "../utils/deviceDetection";

// Redirects users to the appropriate app store based on their device
const AppDownloadRedirect = () => {
  useEffect(() => {
    const iosAppStoreUrl = "https://apps.apple.com/in/app/gigfws-post-apply-gig-jobs/id6752988240?utm_source=website&utm_medium=qr_code&utm_campaign=app_download";
    const androidPlayStoreWebUrl = "https://play.google.com/store/apps/details?id=com.futureworkforce&utm_source=website&utm_medium=qr_code&utm_campaign=app_download";
    
    if (isIOSDevice()) {
      window.location.href = iosAppStoreUrl;
    } else if (isAndroidDevice()) {
      window.location.href = androidPlayStoreWebUrl;
    } else {
      window.location.href = androidPlayStoreWebUrl;
    }
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <p>Redirecting to app store...</p>
    </div>
  );
};

export default AppDownloadRedirect;

